function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDeclined({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 512 512",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 13.787,
    y: 138.827,
    style: {
      fill: "#F4B2B0"
    },
    width: 433.768,
    height: 54.212
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#F4B2B0"
    },
    cx: 185.58,
    cy: 304.663,
    r: 39.545
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#B3404A"
    },
    d: "M185.578,251.33c-29.409,0-53.333,23.925-53.333,53.334c0,3.148,0.29,6.226,0.815,9.225 c-0.131,0.263-0.269,0.521-0.385,0.796c-4.044,9.56-13.361,15.736-23.739,15.736c-14.202,0-25.758-11.555-25.758-25.758 c0-14.204,11.554-25.759,25.758-25.759c7.615,0,13.787-6.174,13.787-13.787s-6.173-13.788-13.787-13.788 c-29.407,0-53.333,23.925-53.333,53.334c0,29.407,23.925,53.333,53.333,53.333c14.771,0,28.503-6.044,38.362-16.253 c9.701,10.011,23.272,16.253,38.28,16.253c29.409,0,53.333-23.925,53.333-53.333C238.911,275.254,214.986,251.33,185.578,251.33z  M185.578,330.421c-14.203,0-25.758-11.555-25.758-25.758c0-14.204,11.555-25.759,25.758-25.759 c14.202,0,25.758,11.555,25.758,25.759C211.336,318.865,199.781,330.421,185.578,330.421z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#B3404A"
    },
    d: "M461.336,269.021v-130.19c0-7.613-6.173-13.787-13.788-13.787H27.575V94.58h419.974 c7.615,0,13.788-6.174,13.788-13.787c0-7.613-6.173-13.787-13.788-13.787H13.787C6.173,67.005,0,73.179,0,80.793v310.383 c0,7.613,6.173,13.788,13.787,13.788h328.635c16.84,24.171,44.819,40.032,76.446,40.032c51.353,0,93.132-41.779,93.132-93.132 C512,315.805,491.386,284.489,461.336,269.021z M433.762,152.62v26.64H27.575v-26.64L433.762,152.62L433.762,152.62z  M27.575,377.388V206.835h406.187v53.103c-4.852-0.783-9.824-1.206-14.893-1.206c-15.311,0-29.756,3.736-42.511,10.312h-95.219 c-7.615,0-13.788,6.174-13.788,13.787c0,7.613,6.173,13.788,13.788,13.788h62.812c-3.699,5.003-6.899,10.393-9.551,16.089h-53.261 c-7.615,0-13.787,6.174-13.787,13.787s6.173,13.788,13.787,13.788h45.346c-0.474,3.798-0.746,7.658-0.746,11.581 c0,8.852,1.267,17.407,3.585,25.525H27.575z M418.868,417.42c-36.148,0-65.555-29.409-65.555-65.557s29.409-65.557,65.555-65.557 s65.557,29.409,65.557,65.557S455.016,417.42,418.868,417.42z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#B3404A"
    },
    d: "M442.874,365.652h-48.011c-7.615,0-13.788-6.174-13.788-13.788s6.173-13.788,13.788-13.788h48.011 c7.615,0,13.788,6.174,13.788,13.788S450.488,365.652,442.874,365.652z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDeclined);
export default __webpack_public_path__ + "static/media/declined.1a2229f2312d60a69ee8241d28b2d6f7.svg";
export { ForwardRef as ReactComponent };